import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import withRouter from 'src/components/withRouter';
import PageCardsContainer from 'src/components/PageCardsContainer';
import Back from '../Back';
import Header from '../Header';
import LandsSelect from '../LandsSelect';
import BookingRecordCard from './components/BookingRecordCard';
import BookingPayoutRecordsViewModel from './viewModel';
import styles from './styles.module.scss';

@observer
class BookingPayoutRecords extends React.Component {
  constructor(props) {
    super(props);
    this.vm = new BookingPayoutRecordsViewModel({ router: props.router });
  }

  componentDidMount() {
    this.vm.didMount();
  }

  render() {
    return (
      <>
        <Back />

        <Header subtitle={this.vm.subtitle} />

        <LandsSelect
          value={this.vm.landId}
          onChange={this.vm.onLandIdChange}
          disabled={this.vm.disabled.landId}
          showSearch
          optionFilterProp="label"
        />

        <PageCardsContainer
          paddingBottom
          onWaypointEnter={this.vm.onWaypointEnter}
        >
          {this.vm.bookings.map((vm) => (
            <BookingRecordCard vm={vm} key={vm.id} />
          ))}
        </PageCardsContainer>
      </>
    );
  }
}

BookingPayoutRecords.propTypes = {
  router: PropTypes.object.isRequired
};

BookingPayoutRecords.defaultProps = {};

export default withRouter(BookingPayoutRecords);
